import { Center, Text } from '@mantine/core'
import { useIntl } from 'react-intl'

export function NoProposalFiles() {
  const intl = useIntl()
  return (
    <Center>
      <Text weight={500} size='sm'>
        {intl.messages['externalSourceProposal.proposalFiles.noFilesMessage']}
      </Text>
    </Center>
  )
}
